const Organizations = (app) => {
  app.post("/organizations/save", async ({ req, res, flash, api }) => {
    const { body } = req;
    const { ownerRoleId, permissionIds } = body;
    const newBody = {
      action: "createOrganization",
      organizationUserStatus: true,
      organizationRoleId: ownerRoleId,
      organizationPermissions: permissionIds,
    };
    try {
      await api(`user-organization`, {
        method: "PUT",
        body: newBody,
      });
      flash("success", "Organization created successfully.");
    } catch (e) {
      flash("error", e.message);
    }
    res.redirect("/coaching-portal/settings/manage-coaches");
  });

  app.post("/organizations/update-user", async ({ req, res, flash, api }) => {
    const { body } = req;

    try {
      await api(`update-user-organization`, {
        method: "PUT",
        body,
      });
      flash("success", "User updated successfully.");
    } catch (e) {
      flash("error", e.message);
    }
    res.redirect("/coaching-portal/settings/manage-coaches");
  });

  app.post("/organizations/delete-user", async ({ req, res, flash, api }) => {
    const { body } = req;
    try {
      await api(`delete-user-organization`, {
        method: "PUT",
        body,
      });
      flash("success", "User deleted successfully.");
    } catch (e) {
      flash("error", e.message);
    }
    res.redirect("/coaching-portal/settings/manage-coaches");
  });

  app.post("/organizations/resend-code", async ({ req, res, flash, api }) => {
    const { body } = req;
    try {
      await api(`resend-code`, {
        method: "POST",
        body,
      });
      flash("success", "Code resent successfully");
    } catch (e) {
      flash("error", e.message);
    }
    res.redirect("/coaching-portal/settings/manage-coaches");
  });

  app.post(
    "/organizations/remove-user",
    async ({ req, res, flash, api, locals }) => {
      const { activeUserToRequest } = locals;
      const { body } = req;
      const { user, organizationUserStatus } = body;
      const { athletes = null, _id } = user;
      const {
        organizationId,
        welcomeVideos,
        email,
        name,
        avatar,
        hideRepMaximums,
        hideE1rm,
        hideStrengthMetrics,
        referAsClients,
        units,
      } = activeUserToRequest;

      try {
        //if the user has athletes, we are going to move those athletes to the owner
        if (!organizationUserStatus && !!athletes && athletes.length > 0) {
          const welcomeVideoShownOwner =
            !!welcomeVideos && welcomeVideos.welcomeVideoShown ? true : false;
          const avatarOwner = avatar ? avatar : null;

          const newBody = {
            inactiveUserId: _id,
            organizationId,
            welcomeVideoShownOwner,
            emailOwner: email,
            nameOwner: name,
            ownerId: activeUserToRequest._id,
            avatarOwner,
            hideRepMaximumsOwner: hideRepMaximums,
            hideE1rmOwner: hideE1rm,
            hideStrengthMetricsOwner: hideStrengthMetrics,
            referAsClientsOwner: referAsClients,
            unitsOwner: units,
          };

          await api(`remove-athletes-inactive-user-organization`, {
            method: "PUT",
            body: newBody,
          });
          flash("success", "User updated successfully.");
          //if not, only change the status
        } else {
          const newBody = {
            inactiveUserId: _id,
            hideRepMaximumsOwner: hideRepMaximums,
            hideE1rmOwner: hideE1rm,
            hideStrengthMetricsOwner: hideStrengthMetrics,
            referAsClientsOwner: referAsClients,
            unitsOwner: units,
            ownerId: activeUserToRequest._id,
          };

          await api(`remove-user-organization`, {
            method: "PUT",
            body: newBody,
          });
          flash("success", "User updated successfully.");
        }
      } catch (e) {
        flash("error", e.message);
      }
      res.redirect("/coaching-portal/settings/manage-coaches");
    }
  );

  app.post(
    "/organizations/invite-coach",
    async ({ req, res, flash, api, load }) => {
      const { body } = req;

      try {
        await api(`organization-invite`, {
          method: "POST",
          body,
        });
        flash("success", "User invited successfully.");
      } catch (e) {
        flash("error", e.message);
      }
      res.redirect("/coaching-portal/settings/manage-coaches");
    }
  );

  app.post(
    "/organizations/re-assign-coach",
    async ({ req, res, flash, api, load }) => {
      const { body } = req;

      try {
        await api(`organization-re-assign-coach`, {
          method: "POST",
          body,
        });
        flash("success", "User reassigned successfully.");
      } catch (e) {
        flash("error", e.message);
      }
      res.redirect("/coaching-portal/athletes");
    }
  );
};

export default Organizations;
